import styled, { css } from "styled-components";

export const FlexWrapper = styled.div`
  display: flex;
  width: ${(props) => props.width || "100%"};
  gap: ${(props) => props.gap};
  flex-direction: ${(props) => props.direction};
  flex-wrap: ${(props) => props.wrap || ""};
  justify-content: ${(props) => props.justify || "flex-start"};
  align-items: ${(props) => props.align || "flex-start"};
  margin: ${(props) => props.margin || 0};
  padding: ${(props) => props.padding || 0};

  ${(props) => props.minWidth && `min-width : ${props.minWidth}px`};

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: ${(props) => props.fixAlign || "center"};
    ${(props) => props.mobileMargin && `margin : ${props.mobileMargin}`};

    width: ${(props) => props.mobileWidth || props.width || "100%"};
  }
`;

export const FlexRowWrapper = styled.div`
  display: flex;
  width: ${(props) => props.width || "100%"};
  gap: ${(props) => props.gap};
  flex-direction: ${(props) => props.direction};
  flex-wrap: ${(props) => props.wrap || ""};
  justify-content: ${(props) => props.justify || "flex-start"};
  align-items: ${(props) => props.align || "flex-start"};
  margin: ${(props) => props.margin || 0};
  ${(props) => props.minWidth && `min-width : ${props.minWidth}px`};
`;

export const Container = styled.div`
  width: ${(props) => props.width || "80%"};
  padding: ${(props) => props.padding || "1rem"};
  margin: ${(props) => props.margin || "0 auto"};
  background-color: ${(props) => props.backgroundColor || "transparent"};
  border-radius: ${(props) => props.borderRadius || "0"};
  max-width: 100%;
  @media screen and (max-width: 768px) {
    width: 95%;
    padding: 4px;
    ${(props) => props.mobileMargin && `margin : ${props.mobileMargin}`};

    ${(props) => props.mobileWidth && `width : ${props.mobileWidth}`};
  }
`;

export const MainWrapeer = styled.div`
  width: 100%;
`;

// TypoGraphy

const baseTextStyle = css`
  font-weight: ${(props) => props.weight || "normal"};
  color: ${(props) => props.color || "#000"};
  text-align: ${(props) => props.align || "center"};
  margin: ${(props) => props.margin || "8px auto"};
  font-family: ${(props) => props.fontFamily || "Nunito"};
  font-style: normal;
  ${(props) => props.lineHeight && `line-height : ${props.lineHeight}`};
`;
export const Text1 = styled.h1`
  font-size: 2.6rem;
  ${baseTextStyle}
  @media screen and (max-width: 1024px) {
    font-size: 2.1rem;
  }
  @media screen and (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const Text2 = styled.h2`
  font-size: 2.5rem;
  ${baseTextStyle}

  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const Text3 = styled.h3`
  font-size: 2.2rem;
  ${baseTextStyle}

  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const Text4 = styled.h4`
  font-size: 2rem;
  ${baseTextStyle}

  @media screen and (max-width: 768px) {
    font-size: 1.4rem;
  }
`;


export const Text4_5 = styled.h4`
  font-size: 1.6rem;
  ${baseTextStyle}

  @media screen and (max-width: 768px) {
    font-size: 1.2rem;
  }
`;


export const Text5 = styled.h5`
  font-size: 1.4rem;
  ${baseTextStyle}

  @media screen and (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const Text5_6 = styled.h5`
  font-size: 1.3rem;
  ${baseTextStyle}

  @media screen and (max-width: 768px) {
    font-size: 1rem;
  }
`;


export const Text6 = styled.h5`
  font-size: 1.1rem;
  ${baseTextStyle}

  @media screen and (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const Text7 = styled.h6`
  font-size: 0.9rem;
  ${baseTextStyle}

  @media screen and (max-width: 768px) {
    font-size: 0.8rem;
  }
`;


//Buttons

export const GradiantButton1 = styled.button`
  width: ${(props) => props.width || "150px"};
  height: ${(props) => props.height || "50px"};
  background-color: ${(props) => props.backgroundColor || "transparent"};
  color: ${(props) => props.color || "#000"};
  font-size: ${(props) => props.fontSize || "1.4rem"};
  margin: ${(props) => props.margin || "0 auto"};
  border: 5px solid transparent;
  border-radius: 20px;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(
    90deg,
    #06d9ca 4.88%,
    #19b6f0 46.67%,
    #6e6cff 86.76%
  );
  &:hover {
    border-image-source: linear-gradient(
      90deg,
      #19b6f0 4.88%,
      #06d9ca 46.67%,
      #6e6cff 86.76%
    );
    /* font-size: 1.6rem; */
    background: linear-gradient(
      90deg,
      #06d9ca 17.68%,
      #19b6f0 39.18%,
      #6e6cff 50%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    transition: font-size 0.2s ease-in-out;
  }
  @media screen and (max-width: 768px) {
    font-size: 1rem;
    max-width: 200px;
  }
  ${(props) =>
    props.borderImage && `border-image-source : ${props.borderImage}`}

  border-radius: 8px;
  -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
`;

export const GradiantText1 = styled(Text1)`
  background: linear-gradient(
    90deg,
    #06d9ca 17.68%,
    #19b6f0 39.18%,
    #6e6cff 50%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: ${(props) => props.fontFamily || "Inter"};

  @media screen and (max-width: 768px) {
    font-size: 1.4rem;
  }
`;  

export const GradiantText2 = styled(Text2)`
  background: linear-gradient(
    90deg,
    #06d9ca 17.68%,
    #19b6f0 39.18%,
    #6e6cff 50%
  );
  font-family: ${(props) => props.fontFamily || "Inter"};

  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media screen and (max-width: 768px) {
    font-size: 1.4rem;
  }
`;  

export const GradiantText3 = styled(Text3)`
  background: linear-gradient(
    90deg,
    #06d9ca 17.68%,
    #19b6f0 39.18%,
    #6e6cff 50%
  );
  font-family: ${(props) => props.fontFamily || "Inter"};

  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media screen and (max-width: 768px) {
    font-size: 1.4rem;
  }

  
`;  

export const ViewMoreButton = styled(GradiantText3)`
  cursor: pointer;

`

